import React, { useState, useEffect } from "react";
import "./Footer.scss";
import logo from "../../images/logo.png";
import { Link } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import { useStoreState } from "easy-peasy";

const Footer = () => {
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [screen, setScreen] = useState(0);
  const paths = useStoreState((state) => state.path.paths);
  const careerpaths = useStoreState((state) => state.careerPath.paths);

  useEffect(() => {
    setScreen(window.innerWidth);
    if (window.innerWidth > 1220) {
      setShow1(true);
      setShow2(true);
      setShow3(true);
      setShow4(true);
    }
  }, []);

  return (
    <div className="footerMain">
      <div className="container">
        <div className="footer">
          {/* <div className="left">
            <img src={logo} alt="logo" />
          </div> */}
          <div className="footerDivider"></div>
          <div className="right">
            <ul className="about">
              <li
                className="head"
                onClick={() => (screen > 1220 ? {} : setShow1(!show1))}
              >
                <a href="javascript:void(0)">
                  О КОМПАНИИ
                  <span className="material-icons footerIconExpand">
                    {!show1 ? "add" : "remove"}
                  </span>
                </a>
              </li>
              <div className="footerDivider"></div>
              <Collapse in={show1}>
                <Link to="/about">
                  <li className="footerLink">О компании</li>
                </Link>
                <Link to="/management">
                  <li className="footerLink">Руководство</li>
                </Link>
                <Link to="/documents">
                  <li className="footerLink">Документы</li>
                </Link>
                <Link to="/news">
                  <li className="footerLink">Новости</li>
                </Link>
                <Link to="/purchase">
                  <li className="footerLink">Закупки</li>
                </Link>
                <Link to="/security">
                  <li className="footerLink">Охрана труда</li>
                </Link>
                <Link to="/actives">
                  <li className="footerLink">Непрофильные активы</li>
                </Link>
                <div className="footerDivider"></div>
              </Collapse>
            </ul>
            <ul className="about">
              <li
                className="head"
                onClick={() => (screen > 1220 ? {} : setShow2(!show2))}
              >
                <a href="javascript:void(0)">
                  ПОКУПАТЕЛЯМ
                  <span className="material-icons footerIconExpand">
                    {!show2 ? "add" : "remove"}
                  </span>
                </a>
              </li>
              <div className="footerDivider"></div>
              <Collapse in={show2}>
                <Link to="/deals">
                  <li className="footerLink">Акции</li>
                </Link>
                <Link to="/bonus">
                  <li className="footerLink">Бонусная программа</li>
                </Link>
                <Link to="/privilege">
                  <li className="footerLink">Льготное обеспечение</li>
                </Link>
                <Link to="/production">
                  <li className="footerLink">Изготовление лекарств</li>
                </Link>
                <Link to="/optica">
                  <li className="footerLink">Оптика</li>
                </Link>
                <Link to="/legal">
                  <li className="footerLink">Оптовым покупателям</li>
                </Link>
                <div className="footerDivider"></div>
              </Collapse>
            </ul>
            {careerpaths && careerpaths.length > 0 && (
              <ul className="about">
                <li
                  className="head"
                  onClick={() => (screen > 1220 ? {} : setShow4(!show4))}
                >
                  <a href="javascript:void(0)">
                    КАРЬЕРА
                    <span className="material-icons footerIconExpand">
                      {!show4 ? "add" : "remove"}
                    </span>
                  </a>
                </li>
                <div className="footerDivider"></div>
                <Collapse in={show4}>
                  {careerpaths.map((elem, ind) => (
                    <Link key={ind} to={"/career/" + elem.path}>
                      <li className="footerLink">{elem.title}</li>
                    </Link>
                  ))}
                  <div className="footerDivider"></div>
                </Collapse>
              </ul>
            )}
            {paths && paths.length > 0 && (
              <ul className="about">
                <li
                  className="head"
                  onClick={() => (screen > 1220 ? {} : setShow3(!show3))}
                >
                  <a href="javascript:void(0)">
                    АКТУАЛЬНОЕ
                    <span className="material-icons footerIconExpand">
                      {!show3 ? "add" : "remove"}
                    </span>
                  </a>
                </li>
                <div className="footerDivider"></div>
                <Collapse in={show3}>
                  {paths.map((elem, ind) => (
                    <Link key={ind} to={"/extra/" + elem.path}>
                      <li className="footerLink">{elem.title}</li>
                    </Link>
                  ))}
                  <div className="footerDivider"></div>
                </Collapse>
              </ul>
            )}
            <ul
              className="menu"
              style={{ width: screen > 1220 ? "100px" : "auto" }}
            >
              <Link to="/rent">
                <li className="head footerLink">АРЕНДА</li>
              </Link>
              <div className="footerDivider"></div>
              <Link to="/storenetwork">
                <li className="head footerLink">АПТЕЧНАЯ СЕТЬ</li>
              </Link>
              <div className="footerDivider"></div>
              <Link to="/contacts">
                <li className="head footerLink">КОНТАКТЫ</li>
              </Link>
              <div className="footerDivider"></div>
            </ul>
          </div>
        </div>
        <div className="bottom">© 2020 Фармация. Все права защищены</div>
      </div>
    </div>
  );
};

export default Footer;
